/**
 * Dashboard API client.
 * Fetch calls to Mercury backend API.
 */

const API_BASE = import.meta.env.VITE_API_URL || '';

async function request(url, accessToken, options = {}) {
  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Request failed' }));
    throw new Error(error.error || `HTTP ${response.status}`);
  }

  return response.json();
}

export async function fetchDashboard(accessToken) {
  return request('/api/dashboard', accessToken);
}

export async function fetchTemplates(accessToken) {
  return request('/api/templates', accessToken);
}

export async function sendTestEmail(accessToken, data) {
  return request('/api/test-email', accessToken, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateTemplate(accessToken, templateId, { subject, html, from }) {
  return request(`/api/templates/${encodeURIComponent(templateId)}`, accessToken, {
    method: 'PUT',
    body: JSON.stringify({ subject, html, from }),
  });
}

export async function resetTemplate(accessToken, templateId) {
  return request(`/api/templates/${encodeURIComponent(templateId)}`, accessToken, {
    method: 'DELETE',
  });
}

export async function fetchHealth(accessToken) {
  return request('/api/health', accessToken);
}

// Collections API (collection = group of wings forming a sequence)

export async function fetchCollections(accessToken) {
  return request('/api/collections', accessToken);
}

export async function fetchCollection(accessToken, collectionId) {
  return request(`/api/collections/${encodeURIComponent(collectionId)}`, accessToken);
}

export async function createCollection(accessToken, definition) {
  return request('/api/collections', accessToken, {
    method: 'POST',
    body: JSON.stringify(definition),
  });
}

export async function updateCollection(accessToken, collectionId, definition) {
  return request(`/api/collections/${encodeURIComponent(collectionId)}`, accessToken, {
    method: 'PUT',
    body: JSON.stringify(definition),
  });
}

export async function updateCollectionStatus(accessToken, collectionId, status) {
  return request(`/api/collections/${encodeURIComponent(collectionId)}/status`, accessToken, {
    method: 'PATCH',
    body: JSON.stringify({ status }),
  });
}
